import { Badge } from "@chakra-ui/react";

import { ChakraText } from "components/ChakraText";

import { AppointmentStatus } from "../application/types/AppointmentStatus";
import { appointmentStatusMessage } from "./appointmentStatusMessage";

interface IProps {
  status: AppointmentStatus;
}

const AppointmentStatusTag = ({ status }: IProps) => {
  switch (status) {
    case AppointmentStatus.Approved:
      return (
        <Badge variant="solid" colorScheme="green">
          <ChakraText fontSize={10}>
            {appointmentStatusMessage[AppointmentStatus.Approved]}
          </ChakraText>
        </Badge>
      );
    case AppointmentStatus.Canceled:
      return (
        <Badge variant="solid" colorScheme="red">
          <ChakraText fontSize={10}>
            {appointmentStatusMessage[AppointmentStatus.Canceled]}
          </ChakraText>
        </Badge>
      );
    case AppointmentStatus.Blocked:
      return (
        <Badge variant="solid" colorScheme="purple">
          <ChakraText fontSize={10}>
            {appointmentStatusMessage[AppointmentStatus.Blocked]}
          </ChakraText>
        </Badge>
      );
    case AppointmentStatus.Pending:
      return (
        <Badge variant="solid" colorScheme="gray">
          <ChakraText fontSize={10}>
            {appointmentStatusMessage[AppointmentStatus.Pending]}
          </ChakraText>
        </Badge>
      );
    default:
      throw new Error(`Appointment status ${status} not found`);
  }
};

export { AppointmentStatusTag };
